/* path: src/Steps/StepOne/Fields/DateSelector/Utils/yeatUtils.js */
import moment from 'moment-timezone';

/**
 * Check if a reservation is a Yeat Last Minute reservation.
 */
export const isYeatLastMinute = (reservation) => {
  return (
    reservation?.reservationType === 'yeat' &&
    reservation?.firstName === 'Yeat' &&
    reservation?.lastName === 'Last Minute'
  );
};

/**
 * For a given date (YYYY-MM-DD, Europe/Brussels) and HH:mm time,
 * return true if that time is in the past (today in Brussels time).
 */
export const isYeatTimeInPastForToday = (formattedDate, hhmm) => {
  if (!formattedDate || !hhmm) return false;
  const now = moment.tz('Europe/Brussels');
  const date = moment.tz(formattedDate, 'YYYY-MM-DD', 'Europe/Brussels');
  if (!date.isValid()) return false;

  if (!date.isSame(now, 'day')) return false;

  const [hStr, mStr] = hhmm.split(':');
  const h = parseInt(hStr, 10);
  const m = parseInt(mStr, 10);
  if (Number.isNaN(h) || Number.isNaN(m)) return false;

  const slotMoment = date.clone().hour(h).minute(m).second(0).millisecond(0);
  return slotMoment.isBefore(now);
};

/**
 * Check if a date has available Yeat reservations for the given guest count.
 * Excludes past Yeat times if the date is today (Europe/Brussels).
 */
export const checkYeatAvailability = (reservations, formattedDate, guests) => {
  if (!reservations || !Array.isArray(reservations) || !guests) {
    return false;
  }

  // Find all Yeat reservations for this date
  let yeatReservations = reservations.filter(
    (reservation) =>
      reservation?.date === formattedDate && isYeatLastMinute(reservation)
  );

  if (yeatReservations.length === 0) {
    return false;
  }

  // Exclude past Yeat times if the date is today (Brussels time)
  yeatReservations = yeatReservations.filter(
    (r) => !isYeatTimeInPastForToday(formattedDate, r.time)
  );

  if (yeatReservations.length === 0) {
    return false;
  }

  // Check if any Yeat reservation can accommodate the guest count
  return yeatReservations.some((reservation) => {
    const minSeats = parseInt(reservation.minSeats, 10) || 0;
    const maxSeats = parseInt(reservation.maxSeats, 10) || 0;
    return guests >= minSeats && guests <= maxSeats;
  });
};
